import { Icon, IconProps } from "@chakra-ui/react";

export function HeroMaskIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 1439 724"
      sx={{
        "& svg": {
          preserveAspectRatio: "xMidYMid meet",
        },
      }}
      {...props}
    >
      <path
        d="M1367 0H287H72.7483C31.5498 0 -1.2481 34.5053 0.840933 75.6507L25.2119 555.661C27.0155 591.184 54.489 620.067 89.8778 623.645L1072.29 722.955C1097.15 725.469 1121.54 714.907 1136.72 695.052L1424.2 319.067C1433.8 306.51 1439 291.142 1439 275.335V72C1439 32.2355 1406.76 0 1367 0Z"
        fill="currentColor"
      />
    </Icon>
  );
}
